(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Aplicacao', Aplicacao);

    Aplicacao.$inject = ['$resource', 'DateUtils'];

    function Aplicacao($resource, DateUtils) {
        var resourceUrl = 'api/aplicacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertLocalDateFromServer(data.criadoEm);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'verififcarSituacao': {
                method: 'GET',
                url: 'api/aplicacaos-status/:id',
                isArray: false
            },
        });
    }
})();
